import React, { useState } from 'react';

const defaultFrase = { phrase: '', trained: false };

const IntentForm = ({ intent, intents, guardarIntent, history, editing }) => {
	const [nuevoIntent, nuevoIntentChanged] = useState(intent);
	const intentLengthValidation = nuevoIntent.intent.length === 0;
    const intentValidation = intents.find((intent) => intent.intent === nuevoIntent.intent) !== undefined;
	return (
		<div style={{ width: '80%', margin: '40px auto' }}>
			<div align='right'>
				<div className='taby'>{editing ? 'Editar' : 'Crear'} Intent</div>
			</div>
			<div className='form-container'>
				{editing ? (
					<h1>{intent.intent}</h1>
				) : (
					<>
						{intentValidation && (
							<>
								<small style={{ color: 'red' }}>Ese intent ya existe</small>
								<br />
							</>
						)}
						<b>Intent </b>
						<input
							onChange={(e) => nuevoIntentChanged({ ...nuevoIntent, intent: e.target.value })}
							value={nuevoIntent.intent}
							style={{ fontSize: 'large' }}></input>
						<br />
					</>
				)}
				<b>Frases</b>
				{nuevoIntent.examples.map((example, index) => (
					<div key={index}>
						<input
							onChange={(e) =>
								nuevoIntentChanged({
									...nuevoIntent,
									examples: [
										...nuevoIntent.examples.slice(0, index),
										{ phrase: e.target.value, trained: false },
										...nuevoIntent.examples.slice(index + 1),
									],
								})
							}
							value={example.phrase}
							style={{ width: '90%', marginTop: 10 }}
							disabled={example.trained}
						/>
						<button
							onClick={() =>
								nuevoIntentChanged({
									...nuevoIntent,
									examples: [...nuevoIntent.examples.slice(0, index), ...nuevoIntent.examples.slice(index + 1)],
								})
							}
							className='remove-button'>
							x
						</button>
					</div>
				))}
				<button
					onClick={() => nuevoIntentChanged({ ...nuevoIntent, examples: [...nuevoIntent.examples, defaultFrase] })}
					className='add-button rectangle'>
					+
				</button>
				<div className='form-actions' align='right'>
					<button className='form-button secondary-button' onClick={() => history.push('/training')}>
						Cancelar
					</button>
					<button
						disabled={(intentLengthValidation || intentValidation) && !editing}
						onClick={() => guardarIntent(nuevoIntent)}
						className='form-button primary-button'>
						Guardar
					</button>
				</div>
			</div>
		</div>
	);
};

export default IntentForm;
